// extracted by mini-css-extract-plugin
module.exports = {"box":"deleteConfirmation_box__1YK5f","content":"deleteConfirmation_content__1hZZD","buttons":"deleteConfirmation_buttons___HuFj"};